module.exports = __webpack_public_path__ + "img/booking-mockup.d66d84f4.png";